import {BaseCurrencyCode} from '@raison/types';
import {atom, useAtomValue, useSetAtom} from 'jotai';
import {atomWithLazy} from 'jotai/utils';
import {appLocalStorage} from '~/shared/persistence';

const PRIMARY_CURRENCY_DECIMALS = 2;

const primaryCurrencyHolder$ = atomWithLazy(() => {
    return (appLocalStorage.balanceCurrency.get() ?? 'EUR') as BaseCurrencyCode;
});

export const primaryCurrency$ = atom(
    get => ({
        code: get(primaryCurrencyHolder$),
        decimals: PRIMARY_CURRENCY_DECIMALS,
    }),
    (_get, set, code: BaseCurrencyCode) => {
        set(primaryCurrencyHolder$, code);
    }
);

export function usePrimaryCurrency() {
    return useAtomValue(primaryCurrency$);
}

export function usePrimaryCurrencySetter() {
    return useSetAtom(primaryCurrency$);
}
